import {
  Bone,
  CardHeaderSkeleton,
  FieldSkeleton,
  Line,
  pick,
  placeholderKeys,
  SkeletonRegion,
} from '@ems/ui/patterns/skeleton-blocks'

const COLOR_KEYS = placeholderKeys('color', 5)
const PREVIEW_KEYS = placeholderKeys('preview', 4)

export function ThemeSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <div>
        <Line size="xl" width="w-20" />
        <Line width="w-96" />
      </div>
      <div className="grid items-start gap-6 lg:grid-cols-[20rem_minmax(0,1fr)]">
        <div className="flex flex-col gap-4">
          <div className="flex gap-2">
            <Bone className="h-7 w-16" />
            <Bone className="h-7 w-16" />
          </div>
          <Bone className="h-12 w-full" />
          <div className="flex flex-col gap-2">
            <Line width="w-16" />
            <div className="divide-y rounded-lg border">
              {COLOR_KEYS.map((key, at) => (
                <div key={key} className="px-3 py-2.5">
                  <Line width={pick(['w-24', 'w-32', 'w-20'], at)} />
                </div>
              ))}
            </div>
          </div>
          <FieldSkeleton control="select" label="w-12" />
          <div className="flex flex-col gap-2">
            <Line size="xs" width="w-16" />
            <Bone className="h-2 w-full rounded-full" />
          </div>
        </div>
        <div className="flex min-w-0 flex-col gap-4">
          <div className="flex flex-col gap-3 rounded-lg border p-4">
            <Bone className="h-9 w-32" />
            <Line width="w-80" />
          </div>
          <div className="bg-background flex flex-col gap-8 rounded-xl border p-4 sm:p-6">
            <div className="flex flex-col gap-2">
              <Line size="2xl" width="w-64" />
              <Line width="w-96" />
            </div>
            <div className="grid gap-4 xl:grid-cols-2">
              {PREVIEW_KEYS.map((key) => (
                <div key={key} className="flex flex-col gap-6 rounded-xl border py-6">
                  <CardHeaderSkeleton title="w-32" description="w-48" />
                  <div className="flex flex-col gap-2 px-6">
                    <Line width="w-2/3" />
                    <Line width="w-1/2" />
                    <Line width="w-5/6" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SkeletonRegion>
  )
}
